import SearchResultPage from "./SearchResultPage";

export default SearchResultPage;
